import { ID } from '@datorama/akita';
import { RelationConfig } from '../../models/relation-config.model';
import { Address } from '../../models/address.model';

export interface RentalHome {
  id: ID;
  owner: string;
  rent: string;
  start_date: string;
  end_date: string;
  cancellation_period: RelationConfig;
  address: Address;
  person_id: number;

  cancellation_period_configuration_id?: number;
}

export function createRentalHome(params: Partial<RentalHome>) {
  return {

  } as RentalHome;
}
